module.exports = "/_next/static/images/MapsJettySorongNew-e01b11d556f2e6d1a21039ef5e43d928.png";